"use client";

import { useTranslations } from "next-intl";
import { useFormContext } from "react-hook-form";

export const FieldError = ({ name }: { name: string }) => {
  const t = useTranslations("web_contact");
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <p role="alert" className="text-sm text-red-600">
      {(errors[name]?.message as string) || t("field_required")}
    </p>
  );
};
